/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiScreeningSearchHit,
    ApiScreeningSearchHitFromJSON,
    ApiScreeningSearchHitToJSON,
    ApiScreeningTestCase,
    ApiScreeningTestCaseFromJSON,
    ApiScreeningTestCaseToJSON,
} from '../models';

export interface TestScreeningCaseRequest {
    apiScreeningTestCase: ApiScreeningTestCase;
}

/**
 * 
 */
export class ScreeningTestCaseApi extends runtime.BaseAPI {

    /**
     */
    async testScreeningCaseRaw(requestParameters: TestScreeningCaseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiScreeningSearchHit>>> {
        if (requestParameters.apiScreeningTestCase === null || requestParameters.apiScreeningTestCase === undefined) {
            throw new runtime.RequiredError('apiScreeningTestCase','Required parameter requestParameters.apiScreeningTestCase was null or undefined when calling testScreeningCase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v2/screening-test-case`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiScreeningTestCaseToJSON(requestParameters.apiScreeningTestCase),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiScreeningSearchHitFromJSON));
    }

    /**
     */
    async testScreeningCase(requestParameters: TestScreeningCaseRequest, initOverrides?: RequestInit): Promise<Array<ApiScreeningSearchHit>> {
        const response = await this.testScreeningCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
